import React from "react";

const defaultTurnoverData = [
  {
    category: "Executives / Senior Managers",
    voluntaryTurnover: "",
    involuntaryTurnover: "",
    classificationStandard: "",
  },
  {
    category: "Mid-Level Managers",
    voluntaryTurnover: "",
    involuntaryTurnover: "",
    classificationStandard: "",
  },
  {
    category: "Professionals (with specialized degrees/certifications)",
    voluntaryTurnover: "",
    involuntaryTurnover: "",
    classificationStandard: "",
  },
  {
    category: "All Others",
    voluntaryTurnover: "",
    involuntaryTurnover: "",
    classificationStandard: "",
  },
];

const WorkforceTurnoverTable = ({ turnoverTable, setTurnoverTable }) => {
  const safeTableData = Array.isArray(turnoverTable)
    ? turnoverTable
    : defaultTurnoverData;

  const handleInputChange = (rowIndex, field, value) => {
    const updatedData = [...safeTableData];
    updatedData[rowIndex][field] = value;
    setTurnoverTable(updatedData);
  };

  return (
    <div>
      <div
        style={{
          marginTop: "20px",
          border: "1px solid #000",
          borderRadius: "8px",
          overflow: "hidden",
          width: "100%",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr
              style={{
                backgroundColor: "#D3C9CE",
                color: "#000",
                fontWeight: "bold",
              }}
            >
              <th style={tableHeaderStyle}>Categories</th>
              <th style={tableHeaderStyle}>Voluntary Turnover (%)</th>
              <th style={tableHeaderStyle}>Involuntary Turnover (%)</th>
              <th style={tableHeaderStyle}>
                Classification Standard Used (e.g., ISCO or internal)
              </th>
            </tr>
          </thead>
          <tbody>
            {safeTableData.map((row, index) => (
              <tr key={index}>
                <td
                  style={{
                    ...tableCellStyle,
                    backgroundColor: "#f5f5f5",
                    fontWeight: "bold",
                  }}
                >
                  {row.category}
                </td>
                <td style={tableCellStyle}>
                  <input
                    type="number"
                    value={row.voluntaryTurnover}
                    onChange={(e) =>
                      handleInputChange(index, "voluntaryTurnover", e.target.value)
                    }
                    style={inputFieldStyle}
                  />
                </td>
                <td style={tableCellStyle}>
                  <input
                    type="number"
                    value={row.involuntaryTurnover}
                    onChange={(e) =>
                      handleInputChange(index, "involuntaryTurnover", e.target.value)
                    }
                    style={inputFieldStyle}
                  />
                </td>
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    value={row.classificationStandard}
                    onChange={(e) =>
                      handleInputChange(index, "classificationStandard", e.target.value)
                    }
                    style={inputFieldStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// Styles (same as reused before)
const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputFieldStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

export default WorkforceTurnoverTable;
